// In-memory cache for the History (Messages) page.
// Vive durante a sessão da aba; intencionalmente NÃO é persistido em storage.
//
// ⚠️ SEGURANÇA MULTI-TENANT: precisa ser limpo em QUALQUER troca de auth
// (login, logout, impersonação) para nunca mostrar os dados de um tenant a
// outro. Isso é feito chamando clearMessagesCache() no AuthContext.
//
// Guarda poucas entradas (LRU) chaveadas pela combinação de filtros, para que
// reentrar na tela com os mesmos filtros seja instantâneo.

import { clearListCache } from './listCache';

const MAX_ENTRIES = 6;
const cache = new Map(); // key -> { data, total, ts }

export function getMessagesCache(key) {
  const hit = cache.get(key);
  if (hit) {
    // Renova a recência (LRU): remove e reinsere no fim.
    cache.delete(key);
    cache.set(key, hit);
    return hit;
  }
  return null;
}

export function setMessagesCache(key, data, total) {
  if (cache.has(key)) cache.delete(key);
  cache.set(key, { data, total, ts: Date.now() });
  // Evict os mais antigos se passar do limite.
  while (cache.size > MAX_ENTRIES) {
    const oldest = cache.keys().next().value;
    cache.delete(oldest);
  }
}

export function clearMessagesCache() {
  cache.clear();
  clearListCache(); // limpa também os caches de lista (Contatos/Grupos) na mesma troca de auth
}
